import { render, staticRenderFns } from "./KpiDisplay.vue?vue&type=template&id=7a2ae284&scoped=true&"
import script from "./KpiDisplay.vue?vue&type=script&lang=js&"
export * from "./KpiDisplay.vue?vue&type=script&lang=js&"
import style0 from "./KpiDisplay.vue?vue&type=style&index=0&id=7a2ae284&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2ae284",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VAvatar,VCol,VIcon,VRow})
